import { JOURNEY_TYPES, SEARCH_PARAMS } from "core/constants";
import { useSearchParams } from "react-router-dom";
import { ValueOf } from "src/utils/types";

// Re-export the smart navigation hook from the canonical module
export { useNavigateToRoute } from 'core/hooks/useOnboardingRouter';
export type { OnboardingRouteParams } from 'core/hooks/useOnboardingRouter';

export const getSearchParams = () => {
    const [searchParams] = useSearchParams();
    const journeyType = searchParams.get(SEARCH_PARAMS.JOURNEY_TYPES)?.toString() as ValueOf<typeof JOURNEY_TYPES>;
    const dataType = searchParams.get(SEARCH_PARAMS.DATA_TYPE)?.toString();
    const digio_doc_id = searchParams.get(SEARCH_PARAMS.DIGIO_DOC_ID)?.toString();
    const success = searchParams.get(SEARCH_PARAMS.SUCCESS)?.toString();
    const mode = searchParams.get(SEARCH_PARAMS.MODE)?.toString();
    const status = searchParams.get(SEARCH_PARAMS.STATUS)?.toString();
    const callbackRedirection = searchParams.get(SEARCH_PARAMS.CALLBACK_REDIRECTION)?.toString();

    return { journeyType, dataType, digio_doc_id, success, mode, status, callbackRedirection };
}
